export default "__VITE_ASSET__CUdoS1jP__";